module.exports = __webpack_public_path__ + "img/other-icon-on.7ea36a92.svg";